module.exports = __webpack_public_path__ + "static/media/location-blue.0a93f268.svg";